module.exports = "/images/home@3x.png?dc93f4117eac14eccf6412de60f14983";